<script setup lang="ts">
const { level = 1 } = defineProps<{
  level?: number;
}>();

const tag = computed(() => `h${level}`);

const classObject = computed(() => `base-heading base-heading--${level}`);
</script>

<template>
  <component :is="tag" :class="classObject"><slot /></component>
</template>

<style lang="scss" scoped>
.base-heading {
  font-weight: bold;
  font-family: "Rubik", sans-serif;
  margin: 0;

  &--1 {
    font-size: 1.6em;
  }

  &--2 {
    font-size: 1.4em;
  }

  &--3 {
    font-size: 1.2em;
  }
}
</style>
